import { Component, EventEmitter, OnChanges, OnInit, Output, Input } from '@angular/core';
import { FeedbackApi } from 'shared/sdk';
import { DeliveryManagerService } from 'shared/views/pms/delivery-manager/delivery-manager.service';
import { CommonService } from '../../services/common.service';
import { PreloaderService } from '../../services/preloader.service';
import { AlertService } from 'shared/services/alert.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { APP_VERSION, BUILD_DATE } from 'community/version';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.css']
})
export class FeedbackFormComponent implements OnInit, OnChanges {
  @Input() fromPage: string;
  @Output() cancel: EventEmitter<boolean> = new EventEmitter;
  user: any;
  feedbackForm: FormGroup;
  location: string;
  constructor(
    private _preloader: PreloaderService,
    private _commonService: CommonService,
    public _deliveryManagerService: DeliveryManagerService,
    private alertService: AlertService,
    private _feedbackApi: FeedbackApi,
    private _fb: FormBuilder,
    private _httpClient: HttpClient,
  ) {
   // this.getLocation();
  }

  ngOnInit() {
     const appData = JSON.parse(localStorage.getItem('appData'));
     this.user =  appData.user;
     this._createForm();
  }

  ngOnChanges() {
    this._resetPage();
  }

  private _createForm() {
    this.feedbackForm = this._fb.group({
      categoryId: 'feedback',
      content: [null, [Validators.required, this._commonService.removeWhiteSpaces]],
      userId: this.user.id,
      userName: `${this.user.firstname} ${this.user.lastname}`,
      userEmail: this.user.email,
      userType: this.user.accessType == 'internal' ? 'MSP' : 'VMS',
      platform: this.fromPage ? `ServiceO Web - ${this.fromPage}` : 'ServiceO Web',
      location: '',
      appVersion: `${APP_VERSION} Build Date(${BUILD_DATE})`,
      status: 'new'
    });

  }

  public onSubmit() {
    if (this.feedbackForm.invalid) { return };
    let finalData = this.feedbackForm.value;
    if (this.location) {
      finalData['location'] = this.location;
    }
    this._preloader.showPreloader();
    this._feedbackApi.create(finalData).subscribe(res => {
      this._createForm();
      this._preloader.hidePreloader();
      this.alertService.success('Feedback has been sent successfully', false, 30);
      setTimeout(() => {
        this.cancel.emit(true);
      }, 2000);
    }, err => {
      this._preloader.hidePreloader();
      this.cancel.emit(true);
      this.alertService.error('Something went wrong');

    })
  }


  get f() {
    return this.feedbackForm.controls;
  }

  private _resetPage() {
    this._createForm();
  }


  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        console.log('latitude, longitude', latitude, longitude)
        if (latitude) {
          this._httpClient.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyD6cyDKRX89OoENcMcx7ueBWNTnb_KeRCM`).subscribe((res: any) => {
            if (res && res.status == 'OK' && res.plus_code && res.plus_code.compound_code) {
              console.log('allResults', res.plus_code.compound_code);
              this.location = res.plus_code.compound_code;
            }
          });
        };
      });
    }
  }
}
